import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {PowerBiService} from "@shared/services/power-bi.service";
import { Observable } from 'rxjs';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeComponent {

    constructor(private service: PowerBiService) {
    }

    public canSeeReportCategory(category: string): Observable<boolean> {
        return this.service.canAccessCategory(category);
    }
}
